import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import InputTextField from "../../../../components/input/inputTextField";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import { alertError, alertSuccess } from "../../../../components/alert/swal";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import ModalCustom from "../../../../components/modal/ModalCustom";
import { LogoutOutlined, LoginOutlined } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import UploadFile from "../../../../components/upload/UploadFile";
import StepperCustom from "../../../../components/step/Stepper";
import MapComponent from "../../../../components/map/Map";
import { workScheduleApi } from "../../../../api/work-schedule/work-schedule.api";
import { alertIcons } from "../../../../assets/icons/icons";
import { useTranslation } from "react-i18next";

type Props = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void; // Accepts a boolean argument
  actionType: string;
  data?: any;
  onFetch?: () => void;
};

const ModalRecordTime: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { isOpenModal, setIsOpenModal, actionType, data, onFetch } = props;

  const dispatch = useDispatch();

  const [coverFile, setCoverFile] = useState(null);
  const [description, setDescription] = useState<string>("");
  const [location, setLocation] = useState<[number, number]>([0, 0]);

  const [tabStep, setTebStep] = useState(0);

  const [messageError, setMessageError] = useState({
    location: false,
    file: false,
    desc: false,
  });

  const handleCheckIn = async (newFile?: File, location?: any) => {

    if (!newFile && !description) {
      // Reset errors
      setMessageError({
        location: false,
        file: false,
        desc: false,
      });

      let hasError = false;

      // Validate location (should be an array with 2 elements for latitude and longitude)
      if (!location || !Array.isArray(location) || location.length < 2) {
        setMessageError((prevState) => ({ ...prevState, location: true }));
        hasError = true;
      }

      // Validate that either newFile or description is provided
      if (!newFile && !description) {
        setMessageError((prevState) => ({
          ...prevState,
          file: true,
          desc: true,
        }));
        hasError = true;
      }

      // If any validation fails, stop execution and show error message
      if (hasError) {
        alertError(t("บันทึกเวลาเข้างานไม่สำเร็จ กรุณาใส่ข้อมูลที่จำเป็น"));
        return;
      }
    } else {
      if (newFile || description) {
        const formData = new FormData();
        if (newFile) {
          formData.append("file", newFile);
        }
        formData.append("latitude", location[0].toString());
        formData.append("longitude", location[1].toString());
        formData.append("work_message", description);

        try {
          if (
          (location[0].toString() && location[1].toString())
          ) {
            dispatch(unsetLoading());
            const response = await workScheduleApi.checkInTimeRecord(formData);
            if (response.status < 300) {
              alertSuccess(
                actionType === "check_in"
                  ? t("บันทึกเวลาเข้างาน")
                  : t("บันทึกเวลาออกงาน"),
                actionType === "check_in"
                  ? t("บันทึกเวลาเข้างาน เรียบร้อยแล้ว")
                  : t("บันทึกเวลาออกงาน เรียบร้อยแล้ว"),
                undefined,
                () => {
                  onFetch && onFetch();
                  setIsOpenModal(false);
                  setTebStep(0);
                }
              );
            }
          }

          else {
            alertError(t("บันทึกเวลาเข้างานไม่สำเร็จ กรุณาใส่ข้อมูลที่จำเป็น"));
          }
        } catch (error) {
          alertError(t("บันทึกเวลาเข้างาน ไม่สำเร็จ"));
        } finally {
          dispatch(unsetLoading());
        }
      }
    }
  };

  const handleCheckOut = async (newFile?: File, location?: number[]) => {
    if (!newFile && !description) {
      // Reset errors
      setMessageError({
        location: false,
        file: false,
        desc: false,
      });

      let hasError = false;


      // Validate location (should be an array with 2 elements for latitude and longitude)
      if (!location || !Array.isArray(location) || location.length < 2) {
        setMessageError((prevState) => ({ ...prevState, location: true }));
        hasError = true;
      }

      // Validate that either newFile or description is provided
      if (!newFile && !description) {
        setMessageError((prevState) => ({
          ...prevState,
          file: true,
          desc: true,
        }));
        hasError = true;
      }

      // If any validation fails, stop execution and show error message
      if (hasError) {
        alertError(t("บันทึกเวลาเข้างานไม่สำเร็จ กรุณาใส่ข้อมูลที่จำเป็น"));
        return;
      }
    }
    else if (location) {
      const formData = new FormData();
      if (newFile) {
        formData.append("file", newFile);
      }
      formData.append("latitude", location[0].toString());
      formData.append("longitude", location[1].toString());
      formData.append("work_message", description);

      try {
        if (
          (!newFile || !description) &&
          location[0].toString() &&
          location[1].toString()
        ) {
          dispatch(unsetLoading());
          const response = await workScheduleApi.checkOutTimeRecord(formData);
          if (response.status < 300) {
            alertSuccess(
              actionType === "check_in"
                ? t("บันทึกเวลาเข้างาน")
                : t("บันทึกเวลาออกงาน"),
              actionType === "check_in"
                ? t("บันทึกเวลาเข้างาน เรียบร้อยแล้ว")
                : t("บันทึกเวลาออกงาน เรียบร้อยแล้ว"),
              undefined,
              () => {
                onFetch && onFetch();
                setIsOpenModal(false);
                setTebStep(0);
              }
            );
          }
        } else {
          alertError(t("บันทึกเวลาออกงานไม่สำเร็จ กรุณาใส่ข้อมูลที่จำเป็น"));
        }
      } catch (error) {
        alertError(t("บันทึกเวลาออกงาน ไม่สำเร็จ"));
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        const newPosition: [number, number] = [latitude, longitude];
        setLocation(newPosition);
      },
      (error) => {
        console.error("Error getting location:", error);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
      }
    );
  }, []);

  const componentRender = [
    {
      step: 0,
      component: (
        <Grid
          item
          xs={12}
          md={12}
          sm={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: "25%",
            paddingRight: "25%",
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {t("ประวัติการเข้างาน")}
          </Typography>
          <Typography variant="body1">
            {t("วัน/เดือน/ปี:")} {data && data.date}
          </Typography>
          <Typography variant="body1">
            {t("เวลาเข้างาน:")} {data && data.check_in}
          </Typography>
        </Grid>
      ),
    },
    {
      step: 1,
      component: (
        <Grid
          item
          xs={12}
          md={12}
          sm={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: "25%",
            paddingRight: "25%",
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {t("ประวัติการเข้างาน")}
          </Typography>
          <Typography variant="body1">
            {t("วัน/เดือน/ปี:")} {data && data.date}
          </Typography>
          <Typography variant="body1">
            {t("เวลาออกงาน:")} {data && data.check_out}
          </Typography>
        </Grid>
      ),
    },
  ];

  const allStep = [
    {
      name: t("เข้างาน"),
      isAccept: false,
      icon: <LoginOutlined />,
    },
    {
      name: t("ออกงาน"),
      isAccept: false,
      icon: <LogoutOutlined />,
    },
  ];

  useEffect(() => {
    if (actionType === "history" && data) {
      // Default values for coordinates if any are null or undefined
      const latitude = tabStep === 0 ? data?.latitude_in : data?.latitude_out;
      const longitude =
        tabStep === 0 ? data?.longitude_in : data?.longitude_out;

      // Fallback to default values if latitude or longitude is missing
      const validLatitude = latitude ?? null;
      const validLongitude = longitude ?? null;

      setLocation([validLatitude, validLongitude]);
    }
  }, [actionType, data, tabStep]);

  return (
    <ModalCustom
      title={
        actionType === "check_in"
          ? t("บันทึกเวลาเข้างาน")
          : actionType === "check_out"
            ? t("บันทึกเวลาออกงาน")
            : t("ประวัติการเข้า-ออกงานของท่าน")
      }
      subTitle={
        actionType !== "history" ? t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน") : ""
      }
      open={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
        setTebStep(0);
      }}
      maxWidth={1200} // Setting a custom width of 1200px
      component={
        <Grid container spacing={3}>
          {actionType === "history" && (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <StepperCustom
                step={tabStep}
                setStep={setTebStep}
                stepLabel={allStep}
                view={true}
              />
            </Grid>
          )}

          {actionType === "history" && (
            <Grid item xs={12} md={12} sm={12}>
              {componentRender
                .filter((item) => item.step === tabStep)
                .map((item, index) => (
                  <div key={index + 1}>{item.component}</div>
                ))}
            </Grid>
          )}

          <Grid item xs={12} md={6}>
            <div
              style={{
                backgroundColor: "gray",
                width: "100%",
                height: "100%",
              }}
            >
              <MapComponent
                propLocation={
                  actionType === "history"
                    ? tabStep === 0 && data
                      ? [data.latitude_in, data.longitude_in]
                      : tabStep === 1 && data
                        ? [data.latitude_out, data.longitude_out]
                        : [0, 0]
                    : location
                }
              />
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            {actionType !== "history" ? (
              <UploadFile
                fileAttachmentName={
                  actionType === "history"
                    ? tabStep === 0
                      ? data && data.file_path_in
                      : data && data.file_path_out
                    : ""
                }
                noClick={!!coverFile}
                file={coverFile}
                onDeleteFile={() => setCoverFile(null)}
                formatText={t("สกุล png,jpg,jpeg ขนาดไม่เกิน 10MB")}
                onDrop={(file) => setCoverFile(file)}
                enableFormatImage
                showImage
                xlSize
                containerHeight="5vh"
                required
                helperText={messageError.file ? t("กรุณาใส่ข้อมูลที่จำเป็น") : ""}
              />
            ) : (
              <>
                <a
                  href={
                    actionType === "history"
                      ? tabStep === 0 && data
                        ? `${data.file_path_in}`
                        : tabStep === 1 && data
                          ? `${process.env.REACT_APP_FILE_BASE_API}/${data.file_path_out}`
                          : "#"
                      : "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: "block", width: "100%", height: "250px" }}
                >
                  <img
                    src={
                      actionType === "history"
                        ? tabStep === 0 && data.file_path_in
                          ? `${process.env.REACT_APP_FILE_BASE_API}/${data.file_path_in}`
                          : tabStep === 1 && data.file_path_out
                            ? `${process.env.REACT_APP_FILE_BASE_API}/${data.file_path_out}`
                            : alertIcons.errorAlert
                        : alertIcons.errorAlert
                    }
                    alt="profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain", // Ensures the image fits within the container without being cropped
                      borderRadius: "8px", // Optional: Add rounded corners if needed
                    }}
                  />
                </a>
                <div className="text-center my-2">
                  {actionType === "history"
                    ? tabStep === 0 && !data.file_path_in
                      ? `not have file upload`
                      : tabStep === 1 && !data.file_path_out
                        ? `not have file upload`
                        : ""
                    : ""}
                </div>
              </>
            )}

            <br />
            <InputTextField
              heading={t("ข้อความ")}
              placeholder={t("ลงเวลาเข้างาน")}
              helperText={messageError.desc ? t("กรุณาใส่ข้อมูลที่จำเป็น") : ""}
              value={
                actionType === "history"
                  ? tabStep === 0
                    ? data && data.detail_in
                    : data && data.detail_out
                  : description
              }
              onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setDescription(e.target.value)
              }
              row={3}
              maxRows={5}
              disablePaddingMultiline
              multiline
              inputHeight={"auto"}
              disabled={actionType !== "check_in" && actionType !== "check_out"}
            />
          </Grid>

          <Grid item xs={12}>
            {actionType === "check_in" || actionType === "check_out" ? (
              <Grid
                container
                justifyContent="center"
                spacing={2}
                sx={{ my: 2 }}
              >
                <Grid item>
                  <ButtonOutlined
                    onClick={() => {
                      setIsOpenModal(false);
                      setTebStep(0);
                    }}
                    mode="del"
                    buttonName={t("ย้อนกลับ")}
                    btnProps={{
                      width: "100px",
                    }}
                  />
                </Grid>
                <Grid item>
                  <ButtonPrimary
                    onClick={() => {
                      actionType === "check_in"
                        ? handleCheckIn(
                          coverFile ? coverFile[0] : undefined,
                          location
                        )
                        : handleCheckOut(
                          coverFile ? coverFile[0] : undefined,
                          location
                        );
                    }}
                    buttonName={t("ยืนยัน")}
                    btnProps={{
                      width: "100px",
                    }}
                    mode="next"
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid container justifyContent="center" sx={{ my: 2 }}>
                <Grid item>
                  <ButtonOutlined
                    onClick={() => {
                      setIsOpenModal(false);
                      setTebStep(0);
                    }}
                    mode="del"
                    buttonName={t("ยกเลิก")}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      }
    />
  );
};

export default ModalRecordTime;
